<template>
  <Fragment>
    <template v-if="$route.name !== 'brandTypeIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <el-button type="primary" class="mr-20" @click="addBrandType"
              >新增品牌</el-button
            >
          </div>
        </section>
      </div>
      <el-row>
        <el-col :span="13"
          ><div class="grid-content bg-purple">
            <el-table :data="brandList" style="width: 100%" border>
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + (brandPageNum - 1) * brandPageSize + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品牌名称" width="100">
                <template slot-scope="scope">
                  <span
                    @click="getBrandTypeInfoById(scope.row)"
                    style="color: #409EFF"
                    >{{ scope.row.brandName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="节点标识" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.brandCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" :fit="true">
                <template slot-scope="scope">
                  <el-button size="mini" @click="editBrandTypeInfo(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteBrand(scope.row)"
                    >删除</el-button
                  >
                  <el-button size="mini" @click="addCategoryType(scope.row)"
                    >新增品类</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20 pagination"
              background
              layout="total,prev, pager, next, jumper"
              :total="brandTotal"
              :page-size="10"
              :current-page="brandPageNum"
              @prev-click="handlePrePage"
              @next-click="handleNextPage"
              @current-change="handleCurrentChange"
            >
            </el-pagination></div
        ></el-col>
        <el-col :span="11"
          ><div class="grid-content bg-purple-light">
            <el-table :data="categorySubList" style="width: 100%" border>
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + (categoryPageNum - 1) * categoryPageSize + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品类名称" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.brandName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="节点标识" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.brandCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" :fit="true">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="editCategoryTypeInfo(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteBrand(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20 pagination"
              background
              layout="total,prev, pager, next, jumper"
              :total="categoryTotal"
              :page-size="10"
              :current-page="categoryPageNum"
              @prev-click="brandHandlePrePage"
              @next-click="brandHandleNextPage"
              @current-change="brandHandleCurrentChange"
            >
            </el-pagination></div
        ></el-col>
      </el-row>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      brandId: "",
      brandNames: "",
      brandList: [],
      brandPageNum: 1,
      brandPageSize: 10,
      brandTotal: 0,
      categorySubList: [],
      categoryPageNum: 1,
      categoryPageSize: 10,
      categoryTotal: 0
    };
  },
  methods: {
    //左侧获取品牌名称信息
    getBrandTypeInfo() {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getDictionaryBrandPage",
        params: {
          brandId: 0,
          pageNum: _this.brandPageNum,
          pageSize: _this.brandPageSize
        }
      };

      _this.$store.dispatch("getBrandTypeList", param).then(() => {
        _this.brandList = _this.$store.state.brandType.brandTypeList.list;
        _this.brandTotal = _this.$store.state.brandType.brandTypeList.total;
        _this.brandId = _this.brandList[0].brandId;
        _this.brandNames = _this.brandList[0].brandName;
        _this.getBrandTypeSubInfo();
      });
    },
    //右侧获取品类名称信息
    getBrandTypeSubInfo() {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getDictionaryBrandPage",
        params: {
          brandId: _this.brandId,
          pageNum: _this.categoryPageNum,
          pageSize: _this.categoryPageSize
        }
      };

      _this.$store.dispatch("getBrandTypeList", param).then(() => {
        _this.categorySubList = _this.$store.state.brandType.brandTypeList.list;
        _this.categoryTotal = _this.$store.state.brandType.brandTypeList.total;
      });
    },
    //右侧品类名称查询
    searchBrandTypeSub() {
      let _this = this;
      _this.getBrandTypeSubInfo();
    },
    //媒体大类点击触发事件
    getBrandTypeInfoById(row) {
      let _this = this;
      _this.brandId = row.brandId;
      _this.brandNames = row.brandName;
      _this.getBrandTypeSubInfo();
    },
    //左侧当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.brandPageNum = value;
      _this.getBrandTypeInfo();
    },
    //左侧上一页
    handlePrePage() {
      let _this = this;
      _this.brandPageNum -= 1;
      _this.getBrandTypeInfo();
    },
    //左侧下一页
    handleNextPage() {
      let _this = this;
      _this.brandPageNum += 1;
      _this.getBrandTypeInfo();
    },
    //右侧当前页
    brandHandleCurrentChange(value) {
      let _this = this;
      _this.categoryPageNum = value;
      _this.searchBrandTypeSub();
    },
    //右侧上一页
    brandHandlePrePage() {
      let _this = this;
      _this.categoryPageNum -= 1;
      _this.searchBrandTypeSub();
    },
    //右侧下一页
    brandHandleNextPage() {
      let _this = this;
      _this.categoryPageNum += 1;
      _this.searchBrandTypeSub();
    },
    //新增品牌
    addBrandType() {
      this.$router.push({
        name: "addBrandType"
      });
    },
    //新增品类
    addCategoryType(row) {
      this.$router.push({
        name: "addCategoryType",
        params: { brandId: row.brandId }
      });
    },
    //编辑品牌
    editBrandTypeInfo(row) {
      this.$router.push({
        name: "editBrandTypeInfo",
        params: { brandId: row.brandId }
      });
    },
    //编辑品类
    editCategoryTypeInfo(row) {
      this.$router.push({
        name: "editCategoryTypeInfo",
        params: { brandId: row.brandId, brandNames: this.brandNames }
      });
    },
    //删除
    deleteBrand: function(row) {
      let _this = this;
      if (confirm("确定要删除吗") === true) {
        let param = {
          url: "/api/dictionaryBrand/deleteDictionaryBrandInfoById",
          params: { brandId: row.brandId }
        };

        _this.$Api
          .get(param.url, param.params)
          .then(response => {
            if (response.status === 200) {
              _this.getBrandTypeInfo();
              _this.$message({
                message: "品牌品类信息删除成功",
                type: "success"
              });
              this.$router.push({
                name: "brandTypeIndex"
              });
            } else {
              _this.$message({
                message: response.data.msg,
                type: "error"
              });
            }
          })
          .catch(err => {});
      }
    }
  },
  created() {
    let _this = this;
    _this.getBrandTypeInfo();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
      display: flex
      align-items: center
      justify-content: space-between

      .left
          display: flex

      .el-button
          font-size: 14px

      .search-name, .search-code
          font-size: 14px
          display: flex
          align-items: center

          span
              white-space: nowrap

  .pagination
      text-align: center
</style>
